export default "__VITE_ASSET__U$pXgNC$__"